module.exports = __webpack_public_path__ + "img/img_security_speaker.1df702e7.svg";